import { createAction, props } from "@ngrx/store";

export const themeSuccess = createAction(
  "[Theme] Switcher Success",
  props<{ currentTheme: string }>()
);
